import { useEffect, useState } from "react";
import { adminGet } from "@/lib/adminApi";
import { frDateTime } from "@/components/admin/ClientFiche";

const TYPE_LABELS = {
  "auth.login": "Connexion réussie",
  "auth.login_failed": "Connexion échouée",
  "keys.update": "Clés modifiées",
  "admins.create": "Administrateur créé",
  "admins.delete": "Administrateur supprimé",
  "users.delete": "Compte supprimé",
  "planning.create": "Plage ajoutée au planning",
  "planning.delete": "Plage supprimée du planning",
  "rgpd.export": "Export RGPD",
  "rgpd.anonymize": "Anonymisation RGPD",
};

export default function Logs() {
  const [logs, setLogs] = useState([]);
  const [types, setTypes] = useState([]);
  const [filter, setFilter] = useState("");

  const load = (t) => {
    adminGet(t ? `/logs?type=${t}` : "/logs").then((d) => {
      setLogs(d.logs);
      setTypes(d.types);
    }).catch(() => {});
  };
  useEffect(() => {
    load("");
  }, []);

  const choose = (t) => {
    setFilter(t);
    load(t);
  };

  return (
    <div data-testid="admin-logs-module">
      <h2 className="rav-admin-h2">Journaux & sécurité</h2>
      <p className="rav-page-sub rav-admin-note">Qui a fait quoi, et quand — connexions, clés, comptes, planning, RGPD.</p>
      <div className="rav-chips rav-admin-chips">
        <button type="button" className={`rav-chip${filter === "" ? " is-selected" : ""}`} data-testid="logs-filter-all" onClick={() => choose("")}>
          Tout
        </button>
        {types.map((t) => (
          <button key={t} type="button" className={`rav-chip${filter === t ? " is-selected" : ""}`} data-testid={`logs-filter-${t}`} onClick={() => choose(t)}>
            {TYPE_LABELS[t] || t}
          </button>
        ))}
      </div>
      {logs.length === 0 && <p className="rav-page-sub">Aucun événement pour le moment.</p>}
      <div className="rav-admin-list">
        {logs.map((l, i) => (
          <div key={l.id} className="rav-admin-row" data-testid={`log-row-${i}`}>
            <span className="rav-admin-row-label">{TYPE_LABELS[l.type] || l.type}</span>
            <span className="rav-admin-row-sub">
              {frDateTime(l.created_at)} · {l.actor || "—"}
              {l.detail ? ` · ${l.detail}` : ""}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
